"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Cell layout to be used inside TableCell
 */
var TableCellLayout =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TableCellLayout, _React$Component);

  function TableCellLayout() {
    _classCallCheck(this, TableCellLayout);

    return _possibleConstructorReturn(this, _getPrototypeOf(TableCellLayout).apply(this, arguments));
  }

  _createClass(TableCellLayout, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          content = _this$props.content,
          before = _this$props.before,
          after = _this$props.after;

      if (content !== undefined) {
        var contentNode = content; // If content element is not a valid element like a string, wrap it
        // inside a span so it can be returned in this render function

        if (!_react.default.isValidElement(content)) {
          contentNode = _react.default.createElement("span", {
            className: "cell-content"
          }, content);
        }

        if (before && !after) {
          return _react.default.createElement(_FlexLayout.default, {
            alignItems: "center",
            itemSpacing: "10px"
          }, before, contentNode);
        } else if (!before && after) {
          return _react.default.createElement(_FlexLayout.default, {
            alignItems: "center",
            itemSpacing: "10px",
            justifyContent: "space-between"
          }, contentNode, after);
        } else if (before && after) {
          return _react.default.createElement(_FlexLayout.default, {
            className: "cell-layout-before-after",
            alignItems: "center",
            itemSpacing: "10px"
          }, before, contentNode, after);
        }

        return contentNode;
      }

      return null;
    }
  }]);

  return TableCellLayout;
}(_react.default.Component);

exports.default = TableCellLayout;
TableCellLayout.defaultProps = {};
TableCellLayout.propTypes = {
  /**
   * Main cell content to be rendered
   */
  content: _propTypes.default.node,

  /**
   * Content to be rendered before main content
   */
  before: _propTypes.default.node,

  /**
   * Content to be rendered after main content
   */
  after: _propTypes.default.node
};